import { CSSProperties } from 'react';
import Spinner from '../spinner';
import { Loading } from './style';

export default ({ style }: { style?: CSSProperties }) => (
  <Loading style={style}>
    <Spinner />
  </Loading>
);
